import { EQuizStatus } from '@constants';
import { IQuiz } from '@sdk/contracts';
import { Button } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { RemoveQuiz } from '../RemoveQuiz';

import { StyledButton, ButtonText, Wrapper } from './Content.styles';

import { Icon } from '@/components/Icon';
import { QuizDeleteActivityModal } from '@/components/QuizDeleteActivityModal';
import { useQuizDeletionModal } from '@/hooks';
import { useActivityByQuiz, useMutateMyQuizzes, useProfile } from '@/store';

type Props = {
  quiz: IQuiz;
};

export const Content: FC<Props> = ({ quiz }) => {
  const { t } = useTranslation('ManagerQuizzesTranslations');
  const { isWorking, toggleQuizStatus, duplicateQuiz, removeQuiz } = useMutateMyQuizzes();
  const { activities } = useActivityByQuiz(quiz._id);
  const { setQuizId } = useQuizDeletionModal();

  const handleDeleteQuiz = () => {
    if (activities?.length) {
      setQuizId(quiz._id);
      return;
    }
    removeQuiz(quiz._id);
  };

  const {
    roleCheck: { isManager }
  } = useProfile();
  const isInReview = quiz.status === EQuizStatus.DRAFT;

  const handleToggleStatus = (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e?.stopPropagation();
    toggleQuizStatus(quiz._id);
  };

  const handleDuplicate = (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e?.stopPropagation();
    duplicateQuiz(quiz._id);
  };

  const handlePassBlankQuiz = (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e?.stopPropagation();
    toggleQuizStatus(quiz._id);
  };

  return (
    <Wrapper>
      {isManager && (
        <StyledButton
          type="link"
          size="small"
          disabled={isWorking}
          onClick={handleToggleStatus}
          icon={<Icon i={isInReview ? 'ViewFilled' : 'ViewOffFilled'} />}>
          <ButtonText>{isInReview ? t('SET_AS_PUBLISHED') : t('SET_AS_DRAFT')}</ButtonText>
        </StyledButton>
      )}

      <Button
        type="link"
        loading={isWorking}
        icon={<Icon i="Copy" color="black9" />}
        onClick={handleDuplicate}>
        <ButtonText>{t('DUPLICATE_QUIZ')}</ButtonText>
      </Button>

      {quiz.status === EQuizStatus.PUBLISHED && !isManager && (
        <Button
          type="link"
          loading={isWorking}
          icon={<Icon i="Undo" color="black9" />}
          onClick={handlePassBlankQuiz}>
          <ButtonText>{t('PASS_DRAFT_QUIZ')}</ButtonText>
        </Button>
      )}

      <RemoveQuiz quiz={quiz} onDelete={handleDeleteQuiz} />

      <QuizDeleteActivityModal />
    </Wrapper>
  );
};
